import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, authFetch } from '../utils/api';
import AdminCompany from './AdminCompany';
import AdminLogs from './AdminLogs';
import AdminTransactionFees from './AdminTransactionFees';
import AdminAuctionBuyers from './AdminAuctionBuyers';
import AdminChatReports from './AdminChatReports';
import AdminAuctionDataPage from './AdminAuctionDataPage';
import AdminOwnerConsent from './AdminOwnerConsent';
import AdminConsult from './AdminConsult';
import AdminGuides from './AdminGuides';
import AdminFaqStats from './AdminFaqStats';
import CustomModal from './CustomModal';

function AdminPage({showToast}){
  var navigate = useNavigate();
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };
  var[tab,setTab]=useState('companies');
  var[companies,setCompanies]=useState([]);
  var[expandedCompany,setExpandedCompany]=useState(null);
  var[companyUsers,setCompanyUsers]=useState({});
  var[showCompanyModal,setShowCompanyModal]=useState(false);
  var[editCompany,setEditCompany]=useState(null);
  var[companyForm,setCompanyForm]=useState({name:'',ceo:'',bizNo:'',address:'',tel:'',email:'',bizType:'',bizItem:'',openDate:'',companyType:'일반업체'});
  var[companyFilter,setCompanyFilter]=useState('all');
  var[showNoticeModal,setShowNoticeModal]=useState(false);
  var[noticeList,setNoticeList]=useState([]);
  var[noticeForm,setNoticeForm]=useState({title:'',content:'',priority:'info'});
  var[editNotice,setEditNotice]=useState(null);
  function fetchNotices(){authFetch(API+'/admin/notices').then(function(r){return r.json()}).then(function(d){setNoticeList(d||[])}).catch(function(){})}
  function saveNotice(){
    if(!noticeForm.title.trim()){showToast&&showToast('제목을 입력하세요','error');return;}
    var url=editNotice?API+'/admin/notices/'+editNotice.id:API+'/admin/notices';
    var method=editNotice?'PUT':'POST';
    var body=editNotice?Object.assign({},noticeForm,{active:editNotice.active}):noticeForm;
    fetch(url,{method:method,headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).then(function(){
      setEditNotice(null);setNoticeForm({title:'',content:'',priority:'info'});fetchNotices();
      showToast&&showToast(editNotice?'수정 완료':'공지 등록 완료','success');
    });
  }
  var[ocrLoading,setOcrLoading]=useState(false);
  var[ocrPreview,setOcrPreview]=useState(null);
  var[ocrResultPopup,setOcrResultPopup]=useState(false);
  var[ocrEdit,setOcrEdit]=useState({name:'',ceo:'',bizNo:'',address:'',tel:'',bizType:'',bizItem:'',openDate:''});
  var[showUserModal,setShowUserModal]=useState(false);
  var[userModalCompanyId,setUserModalCompanyId]=useState(null);
  var[userForm,setUserForm]=useState({userId:'',password:'1234',name:'',role:'user',phone:''});
  var[editUser,setEditUser]=useState(null);
  var[showEditUserModal,setShowEditUserModal]=useState(false);
  var[editUserForm,setEditUserForm]=useState({name:'',role:'user',phone:'',active:1});
  var[sysLogs,setSysLogs]=useState([]);var[sysStats,setSysStats]=useState({totalErrors:0,apiErrors:0,uncaughtExceptions:0,unhandledRejections:0});var[logFilter,setLogFilter]=useState('all');var[expandedLog,setExpandedLog]=useState(null);
  var[activityLogs,setActivityLogs]=useState([]);
  var[ocrStats,setOcrStats]=useState({todayCount:0,monthCount:0,byType:[]});
  function fetchLogs(){authFetch(API+'/admin/logs?type='+logFilter).then(function(r){return r.json()}).then(function(d){setSysLogs(d.logs||[])});authFetch(API+'/admin/api-stats').then(function(r){return r.json()}).then(function(d){setSysStats(d)});authFetch(API+'/admin/activity-logs').then(function(r){return r.json()}).then(function(d){setActivityLogs(d.logs||[])});authFetch(API+'/admin/ocr-stats').then(function(r){return r.json()}).then(function(d){setOcrStats(d)})}
  var[logType,setLogType]=useState('all');
  var[logDateFrom,setLogDateFrom]=useState('');
  var[logDateTo,setLogDateTo]=useState('');

  var tabs=[{k:'companies',l:'업체/계정 관리',icon:'🏢'},{k:'privacy',l:'개인정보 로그',icon:'🔐'},{k:'fees',l:'거래수수료',icon:'💰'},{k:'buyers',l:'외부 바이어',icon:'👥'},{k:'consult',l:'상담',icon:'🗨️'},{k:'guides',l:'가이드 관리',icon:'📖'},{k:'faqstats',l:'질문 통계',icon:'📈'},{k:'chatreports',l:'채팅 신고',icon:'💬'},{k:'consent',l:'자관법 동의',icon:'🚗'},{k:'auctiondata',l:'경매 시세',icon:'📊'},{k:'email',l:'이메일/SMTP',icon:'📧'},{k:'logs',l:'시스템 로그',icon:'📋'},{k:'billing',l:'결제/구독',icon:'💳'}];
  var[privacyLogs,setPrivacyLogs]=useState([]);
  var fetchPrivacyLogs=function(){authFetch(API+'/admin/privacy-logs').then(function(r){return r.json()}).then(function(d){if(d.success)setPrivacyLogs(d.logs||[])}).catch(function(){})};
  var[deleteReqs,setDeleteReqs]=useState([]);
  var fetchDeleteReqs=function(){authFetch(API+'/admin/delete-requests').then(function(r){return r.json()}).then(function(d){if(d.success)setDeleteReqs(d.requests||[])}).catch(function(){})};
  var th={padding:'10px 14px',fontSize:13,fontWeight:600,color:'#64748b',textAlign:'left',borderBottom:'2px solid #cbd5e1',background:'#f8fafc',position:'sticky',top:0,zIndex:1};
  var td={padding:'10px 14px',fontSize:13,borderBottom:'1px solid #f0f0f0',verticalAlign:'middle'};
  var badge=function(status,label){var colors={active:{bg:'#dcfce7',c:'#166534'},'활성':{bg:'#dcfce7',c:'#166534'},trial:{bg:'#fef3c7',c:'#92400e'},inactive:{bg:'#fee2e2',c:'#991b1b'},'비활성':{bg:'#fee2e2',c:'#991b1b'},connected:{bg:'#dcfce7',c:'#166534'},none:{bg:'#f1f5f9',c:'#64748b'}};var s=colors[status]||colors.none;return <span style={{background:s.bg,color:s.c,padding:'2px 10px',borderRadius:10,fontSize:11,fontWeight:600}}>{label||status}</span>};
  var btnStyle={padding:'8px 16px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'};
  var inputStyle={width:'100%',padding:'8px 12px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13,boxSizing:'border-box'};
  var modalOverlay={position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999};
  var modalBox={background:'#fff',borderRadius:12,padding:24,width:460,maxHeight:'80vh',overflow:'auto'};

  // `?tab=` 직접 진입 — 계정 관리(v2)의 P3 '외부 바이어' 항목이 이 탭으로 보낸다. 값은 tabs 배열로 검증.
  useEffect(function(){
    var m=/[?&]tab=([a-z]+)/.exec(window.location.search||'');
    if(m&&tabs.some(function(t){return t.k===m[1]}))setTab(m[1]);
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function(){ if(tab==='companies') fetchCompanies(); },[tab]);

  function fetchCompanies(){
    authFetch(API+'/admin/companies').then(function(r){return r.json()}).then(function(data){
      // 403 응답({error:'...'}) 등 비-배열 응답 방어
      setCompanies(Array.isArray(data)?data:[]);
    }).catch(function(){ setCompanies([]); });
  }

  function fetchUsers(companyId){
    authFetch(API+'/admin/companies/'+companyId+'/users').then(function(r){return r.json()}).then(function(data){
      setCompanyUsers(function(prev){var n=Object.assign({},prev);n[companyId]=data;return n});
    });
  }

  function handleExpandCompany(id){
    if(expandedCompany===id){setExpandedCompany(null);return;}
    setExpandedCompany(id);
    fetchUsers(id);
  }

  function openAddCompany(){
    setEditCompany(null);
    setCompanyForm({name:'',ceo:'',bizNo:'',address:'',tel:'',email:'',bizType:'',bizItem:'',openDate:'',companyType:'일반업체'});
    setOcrPreview(null);
    setShowCompanyModal(true);
  }

  function openEditCompany(e,c){
    e.stopPropagation();
    setEditCompany(c);
    setOcrPreview(null);
    setCompanyForm({name:c.name,ceo:c.ceo||'',bizNo:c.bizNo||'',address:c.address||'',tel:c.tel||'',email:c.email||'',bizType:c.bizType||'',bizItem:c.bizItem||'',openDate:c.openDate||'',companyType:c.companyType||'일반업체'});
    setShowCompanyModal(true);
  }

  function saveCompany(){
    if(!companyForm.name.trim()){showToast&&showToast('업체명을 입력하세요','error');return;}
    var url=editCompany?API+'/admin/companies/'+editCompany.id:API+'/admin/companies';
    var method=editCompany?'PUT':'POST';
    var body=editCompany?Object.assign({},companyForm,{status:editCompany.status||'활성'}):companyForm;
    fetch(url,{method:method,headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).then(function(){
      setShowCompanyModal(false);
      fetchCompanies();
      showToast&&showToast(editCompany?'업체 정보가 수정되었습니다':'업체가 등록되었습니다','success');
    });
  }

  function handleBizLicenseUpload(file){
    if(!file)return;
    setOcrLoading(true);
    var reader=new FileReader();
    reader.onload=function(ev){setOcrPreview(ev.target.result)};
    reader.readAsDataURL(file);
    var fd=new FormData();
    fd.append('image',file);
    authFetch(API+'/admin/companies/ocr-biz-license',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(res){
      setOcrLoading(false);
      if(res.error){showToast&&showToast(res.error,'error');return;}
      // 서버 응답은 {success:true, data:{…}} (routes/admin.js) — 최상위에서 직접 읽으면 전부 빈 값이었다.
      // 파싱 방식은 v2 useAddCompany.js:38 · CompanyListPage.js:78 과 동일하게 통일.
      if(!(res.success&&res.data)){showToast&&showToast('사업자등록증 인식 실패','error');return;}
      var data=res.data;
      setOcrEdit({name:data.name||'',ceo:data.ceo||'',bizNo:data.bizNo||'',address:data.address||'',tel:data.tel||'',bizType:data.bizType||'',bizItem:data.bizItem||'',openDate:data.openDate||''});
      setOcrResultPopup(true);
    }).catch(function(){
      setOcrLoading(false);
      showToast&&showToast('사업자등록증 인식 실패','error');
    });
  }

  function toggleCompanyStatus(e,c){
    e.stopPropagation();
    var newStatus=c.status==='활성'?'비활성':'활성';
    var doToggle=function(){
      authFetch(API+'/admin/companies/'+c.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(Object.assign({},c,{status:newStatus}))}).then(function(){fetchCompanies()});
    };
    if(newStatus==='비활성'){
      setModal({type:'danger',title:'이 업체를 비활성화할까요?',message:'',confirmText:'비활성화',onConfirm:function(){closeModal();doToggle();}});
      return;
    }
    doToggle();
  }

  function openAddUser(companyId){
    setUserModalCompanyId(companyId);
    setUserForm({userId:'',password:'1234',name:'',role:'user',phone:''});
    setShowUserModal(true);
  }

  function saveUser(){
    if(!userForm.userId.trim()||!userForm.name.trim()){showToast&&showToast('아이디와 이름을 입력하세요','error');return;}
    authFetch(API+'/admin/companies/'+userModalCompanyId+'/users',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(userForm)}).then(function(r){return r.json()}).then(function(){
      setShowUserModal(false);
      fetchUsers(userModalCompanyId);
      fetchCompanies();
      showToast&&showToast('사용자가 추가되었습니다','success');
    });
  }

  function openEditUser(u){
    setEditUser(u);
    setEditUserForm({name:u.name,role:u.role,phone:u.phone||'',active:u.active,agent_enabled:!!u.agent_enabled});
    setShowEditUserModal(true);
  }

  function saveEditUser(){
    var agentChanged=!!editUserForm.agent_enabled!==!!editUser.agent_enabled;
    var payload=Object.assign({},editUserForm);delete payload.agent_enabled;
    authFetch(API+'/admin/users/'+editUser.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)}).then(function(){
      if(agentChanged)return authFetch(API+'/admin/users/'+editUser.id+'/agent-enabled',{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({enabled:!!editUserForm.agent_enabled})});
    }).then(function(){
      setShowEditUserModal(false);
      if(expandedCompany)fetchUsers(expandedCompany);
      showToast&&showToast('사용자 정보가 수정되었습니다','success');
    });
  }

  function resetPassword(u){
    setModal({type:'confirm',title:'비밀번호를 초기화할까요?',message:u.name+'의 비밀번호를 1234로 변경합니다.',confirmText:'초기화',onConfirm:function(){
      closeModal();
      authFetch(API+'/admin/users/'+u.id+'/reset-password',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({password:'1234'})}).then(function(){
        showToast&&showToast('비밀번호가 초기화되었습니다','success');
      });
    }});
  }

  function toggleUserActive(u){
    var newActive=u.active?0:1;
    authFetch(API+'/admin/users/'+u.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({name:u.name,role:u.role,phone:u.phone||'',active:newActive})}).then(function(){
      if(expandedCompany)fetchUsers(expandedCompany);
    });
  }

  return(
  <div style={{padding:0}}>
    {/* 탭 */}
    <div style={{display:'flex',gap:4,marginBottom:20,borderBottom:'2px solid #e5e7eb',paddingBottom:0}}>
      {tabs.map(function(t){return(
        <button key={t.k} onClick={function(){setTab(t.k)}} style={{padding:'10px 20px',fontSize:13,fontWeight:tab===t.k?700:500,color:tab===t.k?'#1B3A5C':'#64748b',background:tab===t.k?'#fff':'transparent',border:tab===t.k?'2px solid #e5e7eb':'2px solid transparent',borderBottom:tab===t.k?'2px solid #fff':'none',borderRadius:'8px 8px 0 0',cursor:'pointer',marginBottom:-2}}>{t.icon} {t.l}</button>
      )})}
    </div>

    {/* 탭 1: 업체/계정 관리 — P1 과도기 안내. 탭 제거는 계정 관리 화면 검수 후 (최종안 §3 주의) */}
    {tab==='companies'&&<div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap',padding:'10px 14px',marginBottom:12,background:'#eff6ff',border:'1px solid #bfdbfe',borderRadius:8,fontSize:13,color:'#1d4ed8'}}>
      <span style={{fontWeight:700}}>새 계정 관리 화면이 있습니다</span>
      <span style={{color:'#475569'}}>승인 · 요청함 · 전역 검색(⌘K) · 계정/요금제/기본 화면을 한 화면에서.</span>
      <button onClick={function(){navigate('/main/admin-accounts')}} style={{marginLeft:'auto',padding:'6px 12px',background:'#2563EB',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:700,cursor:'pointer'}}>계정 관리 화면으로 이동 →</button>
    </div>}

    {tab==='companies'&&<AdminCompany
      companies={companies} companyUsers={companyUsers} expandedCompany={expandedCompany}
      companyFilter={companyFilter} setCompanyFilter={setCompanyFilter}
      handleExpandCompany={handleExpandCompany} openAddCompany={openAddCompany}
      openEditCompany={openEditCompany} toggleCompanyStatus={toggleCompanyStatus}
      openAddUser={openAddUser} openEditUser={openEditUser}
      resetPassword={resetPassword} toggleUserActive={toggleUserActive}
      showCompanyModal={showCompanyModal} setShowCompanyModal={setShowCompanyModal}
      editCompany={editCompany} companyForm={companyForm} setCompanyForm={setCompanyForm}
      saveCompany={saveCompany} ocrPreview={ocrPreview} ocrLoading={ocrLoading}
      handleBizLicenseUpload={handleBizLicenseUpload}
      ocrResultPopup={ocrResultPopup} setOcrResultPopup={setOcrResultPopup}
      ocrEdit={ocrEdit} setOcrEdit={setOcrEdit} showToast={showToast}
      showUserModal={showUserModal} setShowUserModal={setShowUserModal}
      userForm={userForm} setUserForm={setUserForm} saveUser={saveUser}
      showEditUserModal={showEditUserModal} setShowEditUserModal={setShowEditUserModal}
      editUser={editUser} editUserForm={editUserForm} setEditUserForm={setEditUserForm}
      saveEditUser={saveEditUser} fetchCompanies={fetchCompanies}
      showNoticeModal={showNoticeModal} setShowNoticeModal={setShowNoticeModal}
      noticeList={noticeList} noticeForm={noticeForm} setNoticeForm={setNoticeForm}
      editNotice={editNotice} setEditNotice={setEditNotice}
      saveNotice={saveNotice} fetchNotices={fetchNotices}
      th={th} td={td} badge={badge} btnStyle={btnStyle} inputStyle={inputStyle}
      modalOverlay={modalOverlay} modalBox={modalBox}
    />}

    {/* 개인정보 접근 로그 탭 */}
    {tab==='privacy'&&(function(){if(privacyLogs.length===0)fetchPrivacyLogs();return <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <h3 style={{margin:0,fontSize:16,fontWeight:700,color:'#0f172a'}}>개인정보 접근 로그</h3>
        <button onClick={fetchPrivacyLogs} style={btnStyle}>새로고침</button>
      </div>
      <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'hidden'}}>
        <div style={{maxHeight:500,overflowY:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead><tr>{['일시','사용자','액션','대상','IP'].map(function(h){return <th key={h} style={th}>{h}</th>})}</tr></thead>
          <tbody>
            {privacyLogs.length===0&&<tr><td colSpan={5} style={{...td,textAlign:'center',color:'#94a3b8',padding:40}}>접근 로그가 없습니다</td></tr>}
            {privacyLogs.map(function(l){return <tr key={l.id}>
              <td style={{...td,fontSize:11,whiteSpace:'nowrap'}}>{l.created_at}</td>
              <td style={td}>{l.userName||l.loginId||l.userId}</td>
              <td style={td}><span style={{padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:600,background:l.action==='view_ownerId'?'#fef3c7':l.action==='export_data'?'#dbeafe':'#f1f5f9',color:l.action==='view_ownerId'?'#92400e':l.action==='export_data'?'#1d4ed8':'#64748b'}}>{l.action}</span></td>
              <td style={td}>{l.target}{l.targetId?' (#'+l.targetId+')':''}</td>
              <td style={{...td,fontSize:11,color:'#94a3b8'}}>{l.ip}</td>
            </tr>})}
          </tbody>
        </table>
        </div>
      </div>
    {/* 삭제 요청 */}
    <div style={{marginTop:24}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <h3 style={{margin:0,fontSize:16,fontWeight:700,color:'#0f172a'}}>계정 삭제 요청</h3>
        <button onClick={fetchDeleteReqs} style={btnStyle}>조회</button>
      </div>
      {deleteReqs.filter(function(r){return r.status==='pending'}).length>0?
        deleteReqs.filter(function(r){return r.status==='pending'}).map(function(r){return <div key={r.id} style={{background:'#fef2f2',border:'1px solid #fca5a5',borderRadius:8,padding:'10px 14px',marginBottom:6,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div><span style={{fontWeight:700}}>{r.companyName||'#'+r.companyId}</span> <span style={{color:'#64748b',fontSize:12}}>({r.userName})</span><div style={{fontSize:11,color:'#888',marginTop:2}}>사유: {r.reason||'미입력'} | {r.created_at}</div></div>
          <button onClick={function(){setModal({type:'danger',title:'삭제 처리',message:r.companyName+' 업체의 모든 데이터를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',confirmText:'삭제 처리',onConfirm:function(){closeModal();authFetch(API+'/admin/delete-requests/'+r.id+'/process',{method:'POST'}).then(function(){fetchDeleteReqs()})}})}} style={{padding:'6px 14px',background:'#dc2626',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>처리</button>
        </div>})
        :<div style={{fontSize:13,color:'#94a3b8'}}>대기 중인 삭제 요청이 없습니다</div>}
    </div>
    </div>})()}

    {/* 탭 — 거래수수료 (Wave X-2) */}
    {tab==='fees'&&<AdminTransactionFees showToast={showToast} th={th} td={td} badge={badge} btnStyle={btnStyle} />}

    {/* 탭 — 외부 바이어 (Wave X-3) */}
    {tab==='buyers'&&<AdminAuctionBuyers showToast={showToast} th={th} td={td} badge={badge} btnStyle={btnStyle} />}
    {tab==='consult'&&<AdminConsult showToast={showToast} />}
    {tab==='guides'&&<AdminGuides showToast={showToast} />}
    {tab==='faqstats'&&<AdminFaqStats showToast={showToast} />}

    {/* 탭 — 채팅 신고 (Wave X-4) */}
    {tab==='chatreports'&&<AdminChatReports showToast={showToast} th={th} td={td} badge={badge} btnStyle={btnStyle} />}

    {/* 탭 — 경매 시세 (W2, feat/external-auction-prices) */}
    {tab==='auctiondata'&&<AdminAuctionDataPage showToast={showToast} />}

    {/* 탭 — 자관법 동의 (Wave X-5) */}
    {tab==='consent'&&<AdminOwnerConsent showToast={showToast} th={th} td={td} btnStyle={btnStyle} />}

    {/* 탭 2/3/4 */}
    {(tab==='email'||tab==='logs'||tab==='billing')&&<AdminLogs
      tab={tab}
      sysLogs={sysLogs} sysStats={sysStats} logFilter={logFilter} setLogFilter={setLogFilter}
      expandedLog={expandedLog} setExpandedLog={setExpandedLog}
      activityLogs={activityLogs} ocrStats={ocrStats} fetchLogs={fetchLogs}
      showToast={showToast}
      th={th} td={td} badge={badge} btnStyle={btnStyle}
    />}
    {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
  </div>);
}

export default AdminPage;
